import VerifiedBroadcaster from './verified-broadcaster.png';
import Pro from './pro.png';
import FirstTimer from './first-timer.png';
import ShowOff from './show-off.png';
import CamStar from './cam-star.png';
import KingKam from './king-kam.png';
import Khaleesi from './khaleesi.png';
import DoubleFeature from './double-feature.png';
import Lucky7 from './lucky-7.png';
import TheProfessional from './the-professional.png';
import MarathonCamer from './marathon-camer.png';
import JetSetter from './jet-setter.png';
import NewKid from './new-kid.png';
import OpeningAct from './opening-act.png';
import Trending from './trending.png';
import AlmostFamous from './almost-famous.png';
import TheMainEvent from './the-main-event.png';
import OneYearClub from './one-year-club.png';
import TwoYearClub from './two-year-club.png';
import ThreeYearClub from './three-year-club.png';
import FourYearClub from './four-year-club.png';
import FiveYearClub from './five-year-club.png';
import SixYearClub from './six-year-club.png';
import SevenYearClub from './seven-year-club.png';
import EightYearClub from './eight-year-club.png';
import NineYearClub from './nine-year-club.png';
import TenYearClub from './ten-year-club.png';
import ElevenYearClub from './eleven-year-club.png';
import TwelveYearClub from './twelve-year-club.png';
import ThirteenYearClub from './thirteen-year-club.png';
import FourteenYearClub from './fourteen-year-club.png';
import Boss from './boss.png';
import DickPixPro from './dick-pix-pro.png';
import DtfBff from './dtf-bff.png';
import Exhibitionist from './exhibitionist.png';
import FriendsWithBenefits from './friends-with-benefits.png';
import Magnate from './magnate.png';
import Prospector from './prospector.png';
import Royalty from './royalty.png';
import SelfieStar from './selfie-star.png';
import Member from './member.png';
import SuperModel from './super-model.png';
import TheFriend from './the-friend.png';
import TheModel from './the-model.png';
import TwatShotsPro from './twat-shots-pro.png';
import Tycoon from './tycoon.png';
import Fan from './1-fan.png';
import OneOneThreeSeven from './1337.png';
import BigTipper from './big-tipper.png';
import Bond from './bond.png';
import Cam4Aholic from './cam4-aholic.png';
import CamShowSommelier from './cam-show-sommelier.png';
import CamTour from './cam-tour.png';
import CasinoRoyale from './casino-royale.png';
import ChampagneRoomRegular from './champagne-room-regular.png';
import ChampionOfTheWorld from './champion-of-the-world.png';
import Cinephile from './cinephile.png';
import Collector from './collector.png';
import Crowdfunder from './crowdfunder.png';
import Curious from './curious.png';
import DungeonMaster from './dungeon-master.png';
import Exposer from './exposer.png';
import FattestStacks from './fattest-stacks.png';
import Feeler from './feeler.png';
import FidgetSpinner from './fidget-spinner.png';
import FilmBuff from './film-buff.png';
import Fucker from './fucker.png';
import Gifter from './gifter.png';
import Goat from './goat.png';
import Groupie from './groupie.png';
import GuestOfHonor from './guest-of-honor.png';
import HardAtWork from './hard-at-work.png';
import HellOnWheels from './hell-on-wheels.png';
import HighRoller from './high-roller.png';
import HotTipper from './hot-tipper.png';
import InTheClub from './in-the-club.png';
import KingOfTheHill from './king-of-the-hill.png';
import Kingslayer from './kingslayer.png';
import LapdanceLover from './lapdance-lover.png';
import LeaderBeater from './leader-beater.png';
import LittleTipper from './little-tipper.png';
import Monogamist from './monogamist.png';
import MorningWood from './morning-wood.png';
import MrXxxmas from './mr-xxxmas.png';
import Ninja from './ninja.png';
import OfTheNightsWatch from './of-the-nights-watch.png';
import OneOfTheGang from './one-of-the-gang.png';
import PartyAnimal from './party-animal.png';
import PartyCrasher from './party-crasher.png';
import Peeler from './peeler.png';
import SexTapeEnthusiast from './sex-tape-enthusiast.png';
import SnakeEye from './snake-eye.png';
import SpinDoctor from './spin-doctor.png';
import Spoiler from './spoiler.png';
import SpunOut from './spun-out.png';
import Streaker from './streaker.png';
import Superfan from './superfan.png';
import TheBingeWatcher from './the-binge-watcher.png';
import TheCritic from './the-critic.png';
import TheGambler from './the-gambler.png';
import TheGiver from './the-giver.png';
import TheHeat from './the-heat.png';
import TheHobbyist from './the-hobbyist.png';
import TheMagician from './the-magician.png';
import TheVibrator from './the-vibrator.png';
import TheVirgin from './the-virgin.png';
import Tipper from './tipper.png';
import Toucher from './toucher.png';
import TrainingWheels from './training-wheels.png';
import TreasureHunter from './treasure-hunter.png';
import Unboxer from './unboxer.png';
import PeepingTom from './peeping-tom.png';
import Philanthropist from './philanthropist.png';
import PlayersClub from './players-club.png';
import Poker from './poker.png';
import PrivateDick from './private-dick.png';
import Privateer from './privateer.png';
import Rainmaker from './rainmaker.png';
import ScroogeMcdick from './scrooge-mcdick.png';
import SecretAdmirer from './secret-admirer.png';
import Sensei from './sensei.png';
import Worshipper from './worshipper.png';
import Banksy from './banksy.png';
import Cam4Celebrity from './cam4-celebrity.png';
import Camouflaged from './camouflaged.png';
import Clubber from './clubber.png';
import ClubOwner from './club-owner.png';
import CrowdPleaser from './crowd-pleaser.png';
import CrowdTeaser from './crowd-teaser.png';
import Exclusive from './exclusive.png';
import FromSinCity from './from-sin-city.png';
import Gifted from './gifted.png';
import GoalDigger from './goal-digger.png';
import GoalGetter from './goal-getter.png';
import Goalie from './goalie.png';
import GoalMiner from './goal-miner.png';
import GoalOriented from './goal-oriented.png';
import Handheld from './handheld.png';
import HeirApparent from './heir-apparent.png';
import HideAndSeeker from './hide-and-seeker.png';
import Influencer from './influencer.png';
import MainAttraction from './main-attraction.png';
import OnTheStrip from './on-the-strip.png';
import Organizer from './organizer.png';
import Peekaboo from './peekaboo.png';
import PitBoss from './pit-boss.png';
import PopStar from './pop-star.png';
import Popular from './popular.png';
import Pornographer from './pornographer.png';
import RealityStar from './reality-star.png';
import SpinInstructor from './spin-instructor.png';
import Spoiled from './spoiled.png';
import Spokesmodel from './spokesmodel.png';
import Tagger from './tagger.png';
import TheDealer from './the-dealer.png';
import TheFavorite from './the-favorite.png';
import TheFox from './the-fox.png';
import TheHouse from './the-house.png';
import TheMystic from './the-mystic.png';
import TheOne from './the-one.png';
import TheRage from './the-rage.png';
import TicketMaster from './ticket-master.png';
import Twister from './twister.png';
import Usher from './usher.png';
import VeryGifted from './very-gifted.png';
import VotedMostPopular from './voted-most-popular.png';
import WheelerAndDealer from './wheeler-and-dealer.png';
import WideReceiver from './wide-receiver.png';
import WithTheSpins from './with-the-spins.png';
import Worshipped from './worshipped.png';
import Cam4LabAssistant from './cam4-lab-assistant.png';
import ModSquad from './mod-squad.png';
import TheGraduate from './the-graduate.png';
import Vip from './vip.png';
import SocialButterfly from './social-butterfly.png';
import Socialite from './socialite.png';
import Fanatic from './fanatic.png';
import TheGoalScorer from './the-goal-scorer.png';


const ACHIEVEMENT_IMAGES = {
  'socialite': Socialite,
  'socialbutterfly': SocialButterfly,
  'exclusive': Exclusive,
  'verifiedbroadcaster': VerifiedBroadcaster,
  'pro': Pro,
  'firsttimer': FirstTimer,
  'showoff': ShowOff,
  'camstar': CamStar,
  'kingkam': KingKam,
  'khaleesi': Khaleesi,
  'doublefeature': DoubleFeature,
  'lucky7': Lucky7,
  'theprofessional': TheProfessional,
  'marathon': MarathonCamer,
  'jetsetter': JetSetter,
  'newkidontheblock': NewKid,
  'openingact': OpeningAct,
  'trending': Trending,
  'almostfamous': AlmostFamous,
  'themainevent': TheMainEvent,
  'oneyearclub': OneYearClub,
  'twoyearclub': TwoYearClub,
  'threeyearclub': ThreeYearClub,
  'fouryearclub': FourYearClub,
  'fiveyearclub': FiveYearClub,
  'sixyearclub': SixYearClub,
  'sevenyearclub': SevenYearClub,
  'eightyearclub': EightYearClub,
  'nineyearclub': NineYearClub,
  'tenyearclub': TenYearClub,
  'elevenyearclub': ElevenYearClub,
  'twelveyearclub': TwelveYearClub,
  'thirteenyearclub': ThirteenYearClub,
  'fourteenyearclub': FourteenYearClub,
  'boss': Boss,
  'dickpixpro': DickPixPro,
  'dtfbff': DtfBff,
  'exhibitionist': Exhibitionist,
  'friendwithbenefits': FriendsWithBenefits,
  'magnate': Magnate,
  'member': Member,
  'prospector': Prospector,
  'royalty': Royalty,
  'selfiestar': SelfieStar,
  'supermodel': SuperModel,
  'thefriend': TheFriend,
  'themodel': TheModel,
  'twatshotspro': TwatShotsPro,
  'tycoon': Tycoon,
  '1fan': Fan,
  '1337': OneOneThreeSeven,
  'bigtipper': BigTipper,
  'bond': Bond,
  'cam4aholic': Cam4Aholic,
  'camshowsommelier': CamShowSommelier,
  'camtour': CamTour,
  'casinoroyale': CasinoRoyale,
  'champagneroomregular': ChampagneRoomRegular,
  'championoftheworld': ChampionOfTheWorld,
  'cinephile': Cinephile,
  'collector': Collector,
  'crowdfunder': Crowdfunder,
  'curious': Curious,
  'dungeonmaster': DungeonMaster,
  'exposer': Exposer,
  'fatteststacks': FattestStacks,
  'feeler': Feeler,
  'fidgetspinner': FidgetSpinner,
  'filmbuff': FilmBuff,
  'fucker': Fucker,
  'gifter': Gifter,
  'goat': Goat,
  'groupie': Groupie,
  'fanatic': Fanatic,
  'guestofhonor': GuestOfHonor,
  'hardatwork': HardAtWork,
  'hellonwheels': HellOnWheels,
  'highroller': HighRoller,
  'hottipper': HotTipper,
  'intheclub': InTheClub,
  'kingofthehill': KingOfTheHill,
  'kingslayer': Kingslayer,
  'lapdancelover': LapdanceLover,
  'leaderbeater': LeaderBeater,
  'littletipper': LittleTipper,
  'monogamist': Monogamist,
  'morningwood': MorningWood,
  'mrxxxmas': MrXxxmas,
  'ninja': Ninja,
  'ofthenightswatch': OfTheNightsWatch,
  'oneofthegang': OneOfTheGang,
  'partyanimal': PartyAnimal,
  'partycrasher': PartyCrasher,
  'peeler': Peeler,
  'sextapeenthusiast': SexTapeEnthusiast,
  'snakeeye': SnakeEye,
  'spindoctor': SpinDoctor,
  'spoiler': Spoiler,
  'spunout': SpunOut,
  'streaker': Streaker,
  'superfan': Superfan,
  'thebingewatcher': TheBingeWatcher,
  'thecritic': TheCritic,
  'thegambler': TheGambler,
  'thegiver': TheGiver,
  'theheat': TheHeat,
  'thehobbyist': TheHobbyist,
  'themagician': TheMagician,
  'thevibrator': TheVibrator,
  'thevirgin': TheVirgin,
  'tipper': Tipper,
  'toucher': Toucher,
  'trainingwheels': TrainingWheels,
  'treasurehunter': TreasureHunter,
  'unboxer': Unboxer,
  'peepingtom': PeepingTom,
  'philanthropist': Philanthropist,
  'playersclub': PlayersClub,
  'poker': Poker,
  'privatedick': PrivateDick,
  'privateer': Privateer,
  'rainmaker': Rainmaker,
  'scroogemcdick': ScroogeMcdick,
  'secretadmirer': SecretAdmirer,
  'sensei': Sensei,
  'worshipper': Worshipper,
  'banksy': Banksy,
  'cam4celebrity': Cam4Celebrity,
  'camouflaged': Camouflaged,
  'clubber': Clubber,
  'clubowner': ClubOwner,
  'crowdpleaser': CrowdPleaser,
  'crowdteaser': CrowdTeaser,
  'fromsincity': FromSinCity,
  'gifted': Gifted,
  'goaldigger': GoalDigger,
  'goalgetter': GoalGetter,
  'goalie': Goalie,
  'goalminer': GoalMiner,
  'goaloriented': GoalOriented,
  'handheld': Handheld,
  'heirapparent': HeirApparent,
  'hideandseeker': HideAndSeeker,
  'influencer': Influencer,
  'mainattraction': MainAttraction,
  'onthestrip': OnTheStrip,
  'organizer': Organizer,
  'peekaboo': Peekaboo,
  'pitboss': PitBoss,
  'popstar': PopStar,
  'popular': Popular,
  'pornographer': Pornographer,
  'realitystar': RealityStar,
  'spininstructor': SpinInstructor,
  'spoiled': Spoiled,
  'spokesmodel': Spokesmodel,
  'tagger': Tagger,
  'thedealer': TheDealer,
  'thefavorite': TheFavorite,
  'thefox': TheFox,
  'thehouse': TheHouse,
  'themystic': TheMystic,
  'theone': TheOne,
  'therage': TheRage,
  'ticketmaster': TicketMaster,
  'twister': Twister,
  'usher': Usher,
  'verygifted': VeryGifted,
  'votedmostpopular': VotedMostPopular,
  'wheeleranddealer': WheelerAndDealer,
  'widereceiver': WideReceiver,
  'withthespins': WithTheSpins,
  'worshipped': Worshipped,
  'cam4labassistant': Cam4LabAssistant,
  'modsquad': ModSquad,
  'thegraduate': TheGraduate,
  'vip': Vip,
  'thegoalscorer': TheGoalScorer,
};

export default ACHIEVEMENT_IMAGES;
